import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { PageList, Response } from './types'

class PageInfo {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getPageInfoList = (languageMode?: string) => {
    let url = `/gw1/puja/internal/v1/pages`
    if (languageMode) {
      url += `?language_mode=${languageMode}`
    }
    return this.api.get<Response<PageList>>(url)
  }

  addStoreToPage = (pageId: string, storeId: string) => {
    return this.api.patch(`/gw2/puja/internal/v1/pages/${pageId}/store/${storeId}`)
  }

  updatePages = (pageId: string, payload: any) =>
    this.api.put(`/gw1/puja/internal/v1/pages/${pageId}`, payload)
}

export default PageInfo
